import React from 'react'

function Loader() {
    return (
        <div className="loader-overlay">
            <div className="spinner-border text-warning" role="status"></div>
        </div>
    )
}

export default Loader